(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("accountLearningPath", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learningPlan/learningPath/learningPathView.html",
            controller: ["learningPlanResource", "messageService", "frameworkService", "shoppingCartService", "learningPlanService", "recognitionService", "$rootScope", "$scope", "$sessionStorage", "$state", "$uibModal", "$timeout", "$window", "_", LearningPathCtrl],
            controllerAs: "vm"
        };
        function LearningPathCtrl(learningPlanResource, messageService, frameworkService, shoppingCartService, learningPlanService, recognitionService, $rootScope, $scope, $sessionStorage, $state, $uibModal, $timeout, $window, _) {
            var vm = this;
            vm.loading = true;
            vm.showSpinner = $state.current.name !== "main.learningPath.learningItemModal";
            vm.reloadingPath = false;
            vm.isLoading = false;
            vm.view = "path";
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.accessExpiresNote = false;
            vm.repurchaseNote = false;
            vm.upgradeVersionNote = false;
            vm.notAvailableNote = false;
            vm.requalifyEnabled = false;
            vm.storefrontEnabled = frameworkService.data.tenantFeatures.storefront;
            if ($sessionStorage.learningPlanView) {
                vm.view = $sessionStorage.learningPlanView === "list" ? "list" : "path";
            }
            loadPath();
            /////////////////////////////////////////////////////////
            function loadPath() {
                if (vm.isLoading)
                    return;
                vm.isLoading = true;
                if (!vm.data)
                    vm.reloadingPath = true;
                learningPlanResource.get({ number: vm.number, version: vm.version }, function (data) {
                    vm.disabled = data.status === 0 || data.status === 5 || data.status === 6;
                    if (data.accessExtendedUntilDate)
                        vm.accessExpiresDate = data.accessExtendedUntilDate;
                    else if (data.accessExpiresDate)
                        vm.accessExpiresDate = data.accessExpiresDate;
                    vm.accessExpiresNote = !!data.accessExpiresDate && (data.status === 1 || data.status === 2);
                    if (vm.accessExpiresNote) {
                        vm.accessExpiresDateFormatted = moment.utc(vm.accessExpiresDate).local().format("LLL");
                    }
                    if (data.redo) {
                        if (vm.storefrontEnabled) {
                            if (data.productId) {
                                vm.repurchaseNote = true;
                            }
                            else {
                                //if (data.catalogUrl && data.catalogUrl.length > 0)
                                //	vm.upgradeVersionNote = true;
                                //else
                                vm.notAvailableNote = true;
                            }
                        }
                        else {
                            vm.requalifyEnabled = data.currentVersionPublished && !frameworkService.data.tenant.tenantFeaturesExternalStorefront;
                        }
                    }
                    else {
                        vm.requalifyEnabled = false;
                    }
                    data.priority = _.some(data.items, { 'showAlertIcon': true });
                    var isEqual = vm.data && _.isEqual(angular.copy(vm.data.toJSON()), angular.copy(data.toJSON()));
                    if (!vm.reloadingPath && vm.data && !isEqual) {
                        vm.reloadingPath = true; //Use this to remove and recreate the path every time we load it
                    }
                    //Only updates the vm.data if the data from the server is different
                    if (!isEqual) {
                        //if this is a reload of the path (vm.data has a value), and the data has changed, refresh the learning plan
                        if (vm.data)
                            learningPlanService.refresh();
                        vm.data = data;
                        vm.data.number = $state.params.number;
                        vm.data.version = $state.params.version;
                    }
                    vm.isLoading = false;
                    $timeout(function () {
                        vm.reloadingPath = false;
                        vm.loading = false;
                        if (focusedItem) {
                            $timeout(function () {
                                var el = document.getElementById(focusedItem);
                                if (el)
                                    el.focus();
                                focusedItem = null;
                            }, 1000);
                        }
                    });
                }, function (error) {
                    messageService.error(error);
                });
            }
            var focusedItem;
            vm.openItem = function (item) {
                //skill check
                if (item.learningItemTypeId == 15) {
                    $state.go("main.learnerSkillCheck", { number: vm.number, version: vm.version, code: item.code });
                }
                else {
                    focusedItem = "path-item-" + item.id;
                    $state.go("main.learningPath.learningItemModal", { code: item.code, requiredForRecognition: item.requiredForRecognition });
                }
            };
            vm.openRecognition = function () {
                focusedItem = "recognition-item";
                recognitionService.openLearnerView(vm.data);
            };
            vm.openInformation = function () {
                focusedItem = "information-item";
                $uibModal.open({
                    templateUrl: "app/account/learningPlan/learningPath/modal/informationModalView.html",
                    controller: ["learningPath", function (learningPath) {
                            var vm = this;
                            vm.assignment = learningPath;
                            vm.contentLoaded = true;
                            if (!vm.assignment.isInformationRead)
                                learningPlanResource.markInformationItemRead({ number: $state.params.number, version: $state.params.version }, function () {
                                    vm.assignment.isInformationRead = true;
                                });
                        }],
                    controllerAs: "vm",
                    scope: $scope,
                    ariaLabelledBy: "modal-title",
                    resolve: {
                        learningPath: function () {
                            return vm.data;
                        }
                    }
                }).result.catch(angular.noop);
            };
            vm.changeView = function (view) {
                vm.view = view;
            };
            vm.repurchase = function () {
                var alreadyOnCart = !shoppingCartService.addToCart(vm.data.productId, 1, function () {
                    $state.go("main.shoppingCart");
                });
                if (alreadyOnCart)
                    $state.go("main.shoppingCart");
            };
            vm.requalify = function () {
                if (vm.requalifyClicked)
                    return;
                vm.requalifyClicked = true;
                learningPlanResource.requalify({ number: vm.number, version: vm.version }, function (data) {
                    if (data.value)
                        loadPath();
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            };
            vm.toggleQuickLinks = function () {
                $rootScope.$broadcast("toggleQuickLinks");
            };
            var removeReloadLearningPath = $rootScope.$on("reloadLearningPath", function () {
                loadPath();
            });
            $rootScope.$on("RefreshLearningPath", function () {
                loadPath();
            });
            function setUpWindowBlur() {
                //Only added if learner leaves the page
                $window.addEventListener("focus", setUpWindowFocus);
            }
            function setUpWindowFocus() {
                loadPath();
            }
            //Adds an event in case the course is launched in an app
            $window.addEventListener("blur", setUpWindowBlur);
            //var removeOnRefreshUserLearningPath;
            //var registerOnRefreshUserLearningPath = function () {
            //	removeOnRefreshUserLearningPath = userHubService.onRefreshLearningPath(function () {
            //		loadPath();
            //	});
            //};
            //registerOnRefreshUserLearningPath();
            this.$onDestroy = function () {
                //if (removeOnRefreshUserLearningPath)
                //	removeOnRefreshUserLearningPath();
                if (removeReloadLearningPath)
                    removeReloadLearningPath();
                $window.removeEventListener("blur", setUpWindowBlur);
                $window.removeEventListener("focus", setUpWindowFocus);
            };
        }
    });
}());
